module.exports = __webpack_public_path__ + "img/icon-facebook-circle.63403f2.svg";